import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=2667b0cb&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=2667b0cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667b0cb",
  null
  
)

export default component.exports